<template>
  <v-col class="pa-1 ">
    <div :class="floatRight ? 'text--primary float-right':'text--primary'"
         v-if="source">
      <a target="_blank" class="build-url" :href="source.url">{{ source.buildno }}</a>
      <br/><small :title="source.branch"
                  class="branch-name d-inline-block text-truncate">{{ source.branch }}</small>
    </div>
    <div v-if="!source">
      None
    </div>
  </v-col>
</template>
<script>

export default {
  components: {},
  name: 'SourceArea',
  props: {
    source: {
      type: Object,
      required: false
    },
    floatRight: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {}
}
</script>
<style>
.branch-name {
  max-width: 115px;
}
.build-url{
  text-decoration: none;
}
</style>